// Hook: dispara `onTick` inmediatamente al montar y luego en cada slot
// boundary de 4h UTC (00/04/08/12/16/20). Sustituye a `setInterval(fn, 10min)`
// para que Brief IA, Sentimiento y sparkline se refresquen sincronizados
// exactamente cuando cambia el slot — no antes, no después.
//
// Delta de seguridad: +30s tras el boundary para que el backend ya haya
// generado el nuevo brief. Fallback: si el timeout es >4h por edge case
// (clock skew), lo cap a 4h.
import { useEffect } from "react";

const SLOT_MS = 4 * 60 * 60 * 1000;   // 4h
const SAFETY_DELAY_MS = 30 * 1000;    // 30s post-boundary

function _msUntilNextSlot() {
  const now = new Date();
  const nowUtcMs = now.getTime();
  const currentHourStart = Date.UTC(
    now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(),
    Math.floor(now.getUTCHours() / 4) * 4, 0, 0, 0,
  );
  const nextBoundary = currentHourStart + SLOT_MS;
  const delta = nextBoundary - nowUtcMs + SAFETY_DELAY_MS;
  return Math.min(Math.max(delta, 1000), SLOT_MS + SAFETY_DELAY_MS);
}

export function useSlotBoundary(onTick) {
  useEffect(() => {
    let timer = null;
    let cancelled = false;

    const schedule = () => {
      if (cancelled) return;
      const ms = _msUntilNextSlot();
      timer = setTimeout(async () => {
        if (cancelled) return;
        try { await onTick?.(); } catch { /* ignore */ }
        schedule();  // re-schedule para el próximo slot
      }, ms);
    };

    // Trigger inicial + primer schedule
    (async () => { try { await onTick?.(); } catch { /* ignore */ } })();
    schedule();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
    // onTick es responsabilidad del caller memoizarla con useCallback.
  }, [onTick]);
}

export default useSlotBoundary;
